import { request } from '../utils/apis'
import store from '../store'

export const GET_SUPPLIERS = 'apis/GET_SUPPLIERS'

const apis = [
    { name: 'supplier', type: GET_SUPPLIERS },
]

let initialState = {
    supplier: [],
}

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_SUPPLIERS:
            return {
                ...state,
                supplier: action.items
            }

        default:
            return state
    }
}

apis.forEach(api => {
    request(api.name)
        .then(response => {
            store.dispatch({
                type: api.type,
                items: response.data
            })
        })
        .catch(() => {
            // 
        })
})


// WEBPACK FOOTER //
// ./src/modules/apis.js